interface Props {
	userName?: string | null;
	fullName?: string | null;
}

/**
 * A person's full name with their username underneath, like the Managers table. Falls back to the
 * username alone when there's no full name, and to a dash when there's neither.
 */
export default function PersonName({ userName, fullName }: Props) {
	if (!userName && !fullName) {
		return <span className="text-gray-500">—</span>;
	}

	if (!fullName) {
		return <span>{userName}</span>;
	}

	return (
		<div>
			<div>{fullName}</div>
			{userName && <div className="text-sm text-gray-600">{userName}</div>}
		</div>
	);
}

/**
 * A person's full name, or their username when there's no full name. For use inside sentences.
 */
export function displayName(userName?: string | null, fullName?: string | null) {
	return fullName || userName || "";
}
